import { ComponentPropsWithoutRef } from 'react';
import { Icon } from '../../UI/components/Icon/Icon';

export interface CheckboxIconProps extends Pick<ComponentPropsWithoutRef<'svg'>, 'className'> {
  checked?: boolean | null;
  type?: 'circle' | 'square';
}

export const CheckboxIcon = ({ checked, type = 'circle', className }: CheckboxIconProps) => {
  if (checked) {
    if (type === 'circle') {
      return <Icon icon="checkboxCircleChecked" className={className} />;
    } else if (type === 'square') {
      return <Icon icon="checkboxSquareChecked" className={className} />;
    }
  } else if (checked === false) {
    if (type === 'circle') {
      return <Icon icon="checkboxCircleUnchecked" className={className} />;
    } else if (type === 'square') {
      return <Icon icon="checkboxSquareUnchecked" className={className} />;
    }
  }
};
